// Inicio requerimiento PLUS-0097-H4 / H5 Samunoz
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@envs/environment';
import {
    CambiarContrasenaRecuperacionRequest,
    CambiarContrasenaSesionRequest,
    ConsultarPreguntasRecuperacionResponse,
    ResponseRecuperacionUsuario,
    SolicitarRecuperacionUsuarioRequest,
    ValidarPreguntasRecuperacionRequest,
    ValidarPreguntasRecuperacionResponse,
    ValidarRecuperacionUsuarioRequest,
    ValidarRecuperacionUsuarioResponse
} from '@features/authentication/models/recuperacion-usuario.interface';
import { Observable } from 'rxjs';

/**
 * Cliente HTTP de recuperacion de usuario. Los tres endpoints son publicos
 * (sin Bearer); el interceptor de auth debe omitirlos.
 * Usa CW_AUTH porque GestionUsuariosRest vive en el WAR servicioAuth-rest.
 * PLUS-0097-H5 Flujo 2: agrega consulta/validacion de preguntas (tambien publicos).
 */
@Injectable({
    providedIn: 'root'
})
export class RecuperacionUsuarioService {

    private readonly _httpClient = inject(HttpClient);
    private static readonly BASE_URL = environment.API_URL
        .concat(environment.CW_AUTH)
        .concat('/apimediador/siafpplus/servicioGestionUsuarios');

    public static readonly SOLICITAR_URL = `${RecuperacionUsuarioService.BASE_URL}/solicitarRecuperacionUsuario/v1`;
    public static readonly VALIDAR_URL = `${RecuperacionUsuarioService.BASE_URL}/validarRecuperacionUsuario/v1`;
    public static readonly CAMBIAR_URL = `${RecuperacionUsuarioService.BASE_URL}/cambiarContrasenaRecuperacion/v1`;
    public static readonly CAMBIAR_SESION_URL = `${RecuperacionUsuarioService.BASE_URL}/cambiarContrasenaSesion/v1`;
    // Inicio requerimiento PLUS-0097-H5 Samunoz
    public static readonly CONSULTAR_PREGUNTAS_URL =
        `${RecuperacionUsuarioService.BASE_URL}/consultarPreguntasRecuperacion/v1`;
    public static readonly VALIDAR_PREGUNTAS_URL =
        `${RecuperacionUsuarioService.BASE_URL}/validarPreguntasRecuperacion/v1`;
    // Fin requerimiento PLUS-0097-H5 Samunoz

    /**
     * Indica si la URL es de recuperacion/crear contraseña (sin Bearer).
     */
    public static esUrlPublica(url: string): boolean {
        return url === RecuperacionUsuarioService.SOLICITAR_URL
            || url === RecuperacionUsuarioService.VALIDAR_URL
            || url === RecuperacionUsuarioService.CAMBIAR_URL
            // Inicio requerimiento PLUS-0097-H5 Samunoz
            || url === RecuperacionUsuarioService.CONSULTAR_PREGUNTAS_URL
            || url === RecuperacionUsuarioService.VALIDAR_PREGUNTAS_URL;
        // Fin requerimiento PLUS-0097-H5 Samunoz
    }

    solicitar(request: SolicitarRecuperacionUsuarioRequest): Observable<ResponseRecuperacionUsuario> {
        return this._httpClient.post<ResponseRecuperacionUsuario>(
            RecuperacionUsuarioService.SOLICITAR_URL,
            request
        );
    }

    validar(request: ValidarRecuperacionUsuarioRequest): Observable<ValidarRecuperacionUsuarioResponse> {
        return this._httpClient.post<ValidarRecuperacionUsuarioResponse>(
            RecuperacionUsuarioService.VALIDAR_URL,
            request
        );
    }

    cambiarContrasena(request: CambiarContrasenaRecuperacionRequest): Observable<ResponseRecuperacionUsuario> {
        return this._httpClient.post<ResponseRecuperacionUsuario>(
            RecuperacionUsuarioService.CAMBIAR_URL,
            request
        );
    }

    cambiarContrasenaSesion(request: CambiarContrasenaSesionRequest): Observable<ResponseRecuperacionUsuario> {
        return this._httpClient.post<ResponseRecuperacionUsuario>(
            RecuperacionUsuarioService.CAMBIAR_SESION_URL,
            request
        );
    }

    // Inicio requerimiento PLUS-0097-H5 Samunoz
    /**
     * PLUS-0097-H5 Flujo 2: obtiene las preguntas del usuario (endpoint publico, sin JWT).
     *
     * @param request usuario cifrado RSA
     */
    consultarPreguntasRecuperacion(
        request: SolicitarRecuperacionUsuarioRequest
    ): Observable<ConsultarPreguntasRecuperacionResponse> {
        return this._httpClient.post<ConsultarPreguntasRecuperacionResponse>(
            RecuperacionUsuarioService.CONSULTAR_PREGUNTAS_URL,
            request
        );
    }

    /**
     * PLUS-0097-H5 Flujo 2: valida respuestas y recibe el token de vigencia
     * (mismo formato que el enlace del correo) para cambiar la contraseña.
     *
     * @param request usuario RSA y respuestas
     */
    validarPreguntasRecuperacion(
        request: ValidarPreguntasRecuperacionRequest
    ): Observable<ValidarPreguntasRecuperacionResponse> {
        return this._httpClient.post<ValidarPreguntasRecuperacionResponse>(
            RecuperacionUsuarioService.VALIDAR_PREGUNTAS_URL,
            request
        );
    }
    // Fin requerimiento PLUS-0097-H5 Samunoz
}
// Fin requerimiento PLUS-0097-H4 / H5 Samunoz
